//@ts-ignore
import Tooltip from "components/Elements/Tooltip/Tooltip";
import Button from "components/Elements/Button/Button";

import { memo } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import config from "config";
import { type APIExternalLoginApiRequestPayloadT } from "api/UsersController";

interface GoogleLoginButtonI extends React.HTMLAttributes<HTMLButtonElement> {
  handleApiAuth: (payload: APIExternalLoginApiRequestPayloadT) => void;
}

const googleLogo = `${config.api.resource}/assets/images/connect-with-google-icon.png`;

const GoogleLoginButton = memo(
  ({ handleApiAuth, ...restProps }: GoogleLoginButtonI) => {
    const login = useGoogleLogin({
      onSuccess: (tokenResponse) => {
        const payload: APIExternalLoginApiRequestPayloadT = {
          OAuthProvider: "google",
          OAuthAccessToken: tokenResponse?.access_token,
          Url: window.location.pathname + window.location.search,
        };

        handleApiAuth(payload);
      },
    });
    return (
      //@ts-ignore
      <Tooltip
        id="googleLoginButton"
        tooltipTextKey="google-login-tooltip-text"
      >
        <Button
          className="login-with-google"
          xs
          title="Google"
          //@ts-ignore
          img={{ src: googleLogo, title: "Google" }}
          onClick={login}
          children={undefined}
          {...restProps}
        />
      </Tooltip>
    );
  }
);

export default GoogleLoginButton;
